module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-19.353fcb64.svg";